require('../js/scripts')
require('../sass/style.scss')



// WEBPACK FOOTER //
// ./src/index.js